import { APIClient } from "../api";

export default class ClassificationService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async getClassificationByService(serviceId: number, classificationGroupId: number) {
        if (serviceId == 0) {
            return { data: [] };
        }
        const url = `${this.endpoint}/Classification/Service/${serviceId}/${classificationGroupId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getClassification() {
        const url = `${this.endpoint}/Classification`;

        return this.api({
            method: 'get',
            url
        });
    }
    async getClassificationById(id: number) {
        const url = `${this.endpoint}/Classification/${id}`;

        return this.api({
            method: 'get',
            url
        });
    }
}